import React, { useState } from 'react';
import { FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import ContainerCard from 'components/Containers/Card/ContainerCard';
import { Box, CardContent, Grid } from '@mui/material';
import { useDependencyInjection } from 'hooks/useDependencyInjection';
import HeaderCard from 'components/Containers/Card/HeaderCard';
import GroupButton from 'components/Buttons/ButtonGroup';
import Identification from './components/Identification';
import Address from './components/Address';
import { useLoadDataByLocation } from 'hooks/useLoadDataByLocation';
import { cleanCpfCnpj } from 'utils';

function Client() {
  const {
    classes,
    id,
    disable,
    success,
    error,
    history,
    requestCompleted,
    location,
    loadingRequest,
    api,
  } = useDependencyInjection();

  const [routeSales, setRouteSales] = useState(false);
  const [harvestId, setHarvestId] = useState();

  const formik = useFormik({
    initialValues: {
      name: '',
      type: '',
      cpfCnpj: '',
      observation: '',
      address: '',
      street: '',
      number: '',
      uf: '',
      city: '',
      phone: '',
      nature: '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Campo Obrigatório'),
      street: Yup.string().required('Campo Obrigatório'),
      uf: Yup.string().required('Campo Obrigatório'),
      city: Yup.string().required('Campo Obrigatório'),
      phone: Yup.string().required('Campo Obrigatório'),
      number: Yup.string().required('Campo Obrigatório'),
      cpfCnpj: Yup.string().required('Campo Obrigatório'),
      nature: Yup.string().required('Campo Obrigatório'),
      observation: Yup.string()
        .max(100, 'Máximo de caracteres ultrapassado (100 caracteres).')
        .nullable(),
    }),
    onSubmit: (values) => {
      const payload = { ...values, cpfCnpj: cleanCpfCnpj(values.cpfCnpj) };
      request(payload);
    },
  });

  function setData(data) {
    if (data.sales) {
      setRouteSales(true);
      setHarvestId(data.harvestId);
      return;
    }

    if (!data) return;

    const cpfCnpjCleaned = cleanCpfCnpj(data?.cpfCnpj);

    if (!data.nature) {
      if (cpfCnpjCleaned?.length === 11) {
        data.nature = 'Pessoa Física';
      } else {
        data.nature = 'Pessoa Jurídica';
      }
    }

    formik.setValues({ ...data });
  }

  useLoadDataByLocation({ setData });

  async function request(data) {
    loadingRequest();
    try {
      if (id) {
        await api.put(`/stakeholders/${id}`, { ...data });
      } else {
        await api.post('/clients', { ...data });
      }
      success();
      if (routeSales) {
        history.replace('/sale', { harvestId });
        return;
      }
      history.push('/clients');
    } catch (err) {
      console.log('eerrr', err);

      error();
    } finally {
      requestCompleted();
    }
  }

  return (
    <FormikProvider value={formik}>
      <ContainerCard>
        <form onSubmit={formik.handleSubmit}>
          <Box className={classes.root}>
            <HeaderCard
              title={id ? 'Dados do Cliente' : 'Novo Cliente'}
              tooltipText="Essa tela possibilita realizar o cadastro das informações dos seus clientes e empresas parceiras para facilitar o gerenciamento desses dados."
            />
            <CardContent
              sx={{
                '&.MuiCardContent-root': {
                  padding: 0,
                },
              }}
            >
              <Grid container direction="column" gap={3}>
                <Grid item>
                  <Identification />
                </Grid>
                <Grid item>
                  <Address recoverState={location?.state} />
                </Grid>
              </Grid>
            </CardContent>
          </Box>
          <GroupButton
            deleteRoute="/clients/"
            routeDelete="/clients"
            returnRoute="/clients"
            id={id}
            disable={disable}
            messageDialogError
            message="Deseja realmente excluir esse Cliente?"
          />
        </form>
      </ContainerCard>
    </FormikProvider>
  );
}

export default Client;
